import {
    customerSettingsFragment,
    invoiceFragment,
    invoiceLineItemFragment,
    invoiceNoteFragment,
} from 'apollo/fragments';
import { invoiceSettingsFragment, paymentDetailsFragment } from 'apollo/fragments/organization';
import { gql } from 'graphql.macro';

export const getInvoiceTemplate = gql`
    query invoice($_id: MongoDbObjectId!) {
        invoice(_id: $_id) {
            ...invoiceFields
            gln
            orders
            order {
                _id
                isCertified
                restorations {
                    _id
                    actions {
                        _id
                        code
                        name
                        price {
                            quantity
                            unitPrice
                            vatPercent
                            totalWithoutVat
                            totalWithVat
                        }
                    }
                    materials {
                        _id
                        code
                        name
                        price {
                            quantity
                            unitPrice
                            vatPercent
                            totalWithoutVat
                            totalWithVat
                        }
                    }
                }
                isCreatedByLab
                created {
                    on
                    by {
                        _id
                        fullName
                    }
                }
            }
            dentist {
                _id
                fullName
            }
            mainClinic {
                _id
                customerSettings {
                    ...customerSettingsFields
                }
                invoicing {
                    communication {
                        email
                    }
                }
            }
            costCenter
            lineItems {
                ...invoiceLineItemFields
            }
            invoiceSettings {
                ...invoiceSettingsFields
            }
            paymentDetails {
                ...paymentDetailsFields
            }
        }
    }
    ${invoiceFragment}
    ${customerSettingsFragment}
    ${invoiceLineItemFragment}
    ${invoiceSettingsFragment}
    ${paymentDetailsFragment}
`;

export const getInvoicesTemplate = gql`
    query invoices(
        $filters: InvoiceFilters
        $limit: Int
        $offset: Int
        $orderBy: String
        $orderDirection: OrderDirection
    ) {
        invoices(
            filters: $filters
            limit: $limit
            offset: $offset
            orderBy: $orderBy
            orderDirection: $orderDirection
        ) {
            ...invoiceFields
        }
    }
    ${invoiceFragment}
`;

export const getDelayedInvoicesTemplate = gql`
    query delayedInvoices(
        $filters: InvoiceFilters
        $limit: Int
        $offset: Int
        $orderBy: String
        $orderDirection: OrderDirection
    ) {
        delayedInvoices(
            filters: $filters
            limit: $limit
            offset: $offset
            orderBy: $orderBy
            orderDirection: $orderDirection
        ) {
            ...invoiceFields
        }
    }
    ${invoiceFragment}
`;

export const getInvoicesForDentistTemplate = gql`
    query invoicesForDentist(
        $filters: InvoiceFilters
        $limit: Int
        $offset: Int
        $orderBy: String
        $orderDirection: OrderDirection
    ) {
        invoicesForDentist(
            filters: $filters
            limit: $limit
            offset: $offset
            orderBy: $orderBy
            orderDirection: $orderDirection
        ) {
            ...invoiceFields
            order {
                _id
                isCertified
            }
            lineItems {
                ...invoiceLineItemFields
            }
        }
    }
    ${invoiceFragment}
    ${invoiceLineItemFragment}
`;

export const getOrdersForCollectiveInvoiceTemplate = gql`
    query ordersForCollectiveInvoice($clinics: [MongoDbObjectId!]!, $ordersToDate: Date!) {
        ordersForCollectiveInvoice(clinics: $clinics, ordersToDate: $ordersToDate) {
            clinic
            clinicName
            currency
            ptjCustomerNumber
            dentist
            dentistName
            paymentTerm
            totalPrice
            noOfOrders
            deliveryMethod
            invoiceType
            emails
            lineItems {
                ...invoiceLineItemFields
            }
        }
    }
    ${invoiceLineItemFragment}
`;

export const getInvoiceNotesTemplate = gql`
    query invoiceNotes($filters: InvoiceNoteFilters, $limit: Int, $offset: Int) {
        invoiceNotes(filters: $filters, limit: $limit, offset: $offset) {
            ...invoiceNoteFields
        }
    }
    ${invoiceNoteFragment}
`;

export const getInvoicesExcelExportTemplate = gql`
    query invoicesExcelExport($filters: InvoiceFilters) {
        invoicesExcelExport(filters: $filters)
    }
`;
